'use strict';

document.addEventListener('DOMContentLoaded', function() {
    // Add event listener to the "Read More" label on PDP for keyboard accessibility
    var label = document.querySelector('.read-more-label');
    if (label) {
        var updateAriaExpanded = function() {
            var inputId = label.getAttribute('for');
            var input = document.getElementById(inputId);
            if (input) {
                input.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
                label.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
            }
        };

        label.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                label.click();
                updateAriaExpanded();
            }
        });

        label.addEventListener('click', function() {
            // Delay to ensure input.checked is updated after click
            setTimeout(updateAriaExpanded, 0);
        });
    }
});


